import React from 'react';
import './inputErrors.css';

export function withErrors(errors) {
    return !(!errors || (Array.isArray(errors) && !errors.length))
}

export default function InputErrors({errors = null, id}) {
    if (!withErrors(errors)) {
        return null;
    }


    if (!Array.isArray(errors)) {
        return (
            <p className='neo-input-error-message' id={id}>{errors}</p>
        )
    }

    return (
        <div id={id}>
            {errors.map((error) => (
                <p className='neo-input-error-message'>{error}</p>
            ))}
        </div>
    )
}
